import Hero from "../components/Hero";
import WorkGrid from "../components/WorkGrid";
import Contact from "../components/Contact";
import Logo from "../components/Logo";
import MetaData from "../components/MetaData";
import { motion, useScroll, useTransform } from "framer-motion";
import { useTheme } from "../context/ThemeContext";

const Home = () => {
  const { darkMode } = useTheme();
  const { scrollY } = useScroll();

  // Transform scroll position to opacity
  const opacity = useTransform(
    scrollY,
    [0, 400], // Input range (0-100px scroll)
    [1, 0] // Output range (opacity 1-0)
  );

  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Nova Creations",
    url: "https://www.novacreations.site",
    logo: "https://i.imgur.com/qsv10H9.png",
    description:
      "Professional Minecraft building services specializing in custom houses, castles, terrain, and maps with nearly a decade of experience.",
    foundingDate: "2015",
    industry: "Gaming & Entertainment",
    serviceArea: "Worldwide",
    services: [
      "Custom Minecraft Builds",
      "Minecraft Castle Construction",
      "Terrain Design",
      "Custom Map Creation",
      "Architectural Design",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      url: "https://www.novacreations.site/contact",
    },
  };

  return (
    <div className="min-h-screen">
      <MetaData
        title="Nova Creations - Professional Minecraft Building Services"
        description="Professional Minecraft building services specializing in custom houses, castles, terrain, and maps. Nearly a decade of experience delivering top-tier quality builds for your Minecraft world."
        keywords="minecraft builds, minecraft building services, custom minecraft maps, minecraft houses, minecraft castles, minecraft terrain, professional minecraft builders, minecraft architecture"
        url="https://www.novacreations.site"
        image="https://i.imgur.com/qsv10H9.png"
        structuredData={homeStructuredData}
      />
      <div className="absolute inset-0 -z-5">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: darkMode ? 1 : 0 }}
          style={{ opacity: darkMode ? opacity : 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
          className="fixed inset-0 bg-[linear-gradient(to_right,#2d3c61_1px,transparent_1px),linear-gradient(to_bottom,#2d3c61_1px,transparent_1px)] bg-[size:48px_48px] [mask-image:radial-gradient(ellipse_70%_100%_at_58%_0%,#4d4dff_0%,transparent_110%)]"
        />
      </div>
      <Logo />
      <Hero />
      <WorkGrid />
      <Contact />
    </div>
  );
};

export default Home;
